import React, { Component } from 'react';
import Firebase from 'firebase';
import EventEmitter from '../../helper/Emitter';

class ModalEmailOTP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      hidden: 'hidden',
      step: 1, // 1: enter new email, 2: enter OTP
      newEmail: '',
      otp: '',
      loading: false,
      errorEmail: false,
      errorOtp: false,
      errorMessage: '',
    };
    if (props.show) {
      this.show();
    }
  }

  componentWillReceiveProps(props) {
    if (props.show !== this.props.show) {
      this.setState(
        {
          show: props.show,
        },
        () => {
          if (this.state.show) {
            this.show();
          } else {
            this.hide();
          }
        }
      );
    }
  }

  show() {
    this.setState({
      show: true,
      step: 1,
      newEmail: '',
      otp: '',
      loading: false,
      errorEmail: false,
      errorOtp: false,
      errorMessage: '',
    });
    setTimeout(() => {
      if (this.divElement) {
        const height = this.divElement.clientHeight;
        this.setState({
          hidden: '',
          margin: -height / 2,
        });
      }
    }, 50);
  }

  hide(onComplete) {
    const height = this.divElement ? this.divElement.clientHeight : 300;
    this.setState({
      hidden: 'hidden',
      margin: -height / 2 + 100,
    });
    setTimeout(() => {
      this.setState({ show: false, loading: false });
      this.props.onHide(false);
      if (typeof onComplete === 'function') {
        onComplete();
      }
    }, 300);
  }

  getFunctionsInstance = () => {
    const fn = Firebase.functions();
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      try {
        if (fn.useEmulator) {
          fn.useEmulator('localhost', 5001);
        } else if (fn.useFunctionsEmulator) {
          fn.useFunctionsEmulator('http://localhost:5001');
        }
      } catch (e) {
        // Already initialized
      }
    }
    return fn;
  };

  handleSendOTP = async () => {
    const email = (this.state.newEmail || '').trim().toLowerCase();
    if (!email || !email.includes('@')) {
      this.setState({ errorEmail: true, errorMessage: 'Please enter a valid email address.' });
      return;
    }

    const currentUid = global.uidUser || (Firebase.auth().currentUser && Firebase.auth().currentUser.uid) || this.props.userUid;
    const currentEmail = global.userEmail || (Firebase.auth().currentUser && Firebase.auth().currentUser.email) || this.props.userEmail;

    this.setState({ loading: true, errorEmail: false, errorMessage: '' });

    try {
      const functionsInstance = this.getFunctionsInstance();
      const sendOTP = functionsInstance.httpsCallable('sendEmailChangeOTP');
      const result = await sendOTP({
        newEmail: email,
        uid: currentUid,
        currentEmail: currentEmail,
      });

      if (result && result.data && result.data.success) {
        EventEmitter.dispatch('showMessage', 'Verification code sent to ' + email);
        this.setState({ step: 2, loading: false });
      } else {
        const errMsg = (result && result.data && result.data.message) ? result.data.message : 'Failed to send verification code.';
        this.setState({
          loading: false,
          errorEmail: true,
          errorMessage: errMsg,
        });
      }
    } catch (err) {
      console.error('sendEmailChangeOTP Error:', err);
      this.setState({
        loading: false,
        errorEmail: true,
        errorMessage: err.message || 'Error sending verification code. Please try again.',
      });
    }
  };

  handleVerifyOTP = async () => {
    const otp = (this.state.otp || '').trim();
    const email = (this.state.newEmail || '').trim().toLowerCase();
    const currentUid = global.uidUser || (Firebase.auth().currentUser && Firebase.auth().currentUser.uid) || this.props.userUid;
    const currentEmail = global.userEmail || (Firebase.auth().currentUser && Firebase.auth().currentUser.email) || this.props.userEmail;

    if (!otp || otp.length < 6) {
      this.setState({ errorOtp: true, errorMessage: 'Please enter the 6-digit OTP code.' });
      return;
    }

    this.setState({ loading: true, errorOtp: false, errorMessage: '' });

    try {
      const functionsInstance = this.getFunctionsInstance();
      const verifyOTP = functionsInstance.httpsCallable('verifyAndUpdateEmail');
      const result = await verifyOTP({
        newEmail: email,
        otp: otp,
        uid: currentUid,
        currentEmail: currentEmail,
        customer: global.userStripe,
      });

      if (result && result.data && result.data.success) {
        EventEmitter.dispatch('showMessage', 'Email updated successfully!');
        this.hide(() => {
          if (this.props.onSuccess) {
            this.props.onSuccess(email);
          }
        });
      } else {
        const errMsg = (result && result.data && result.data.message) ? result.data.message : 'Invalid OTP code entered.';
        this.setState({
          loading: false,
          errorOtp: true,
          errorMessage: errMsg,
        });
      }
    } catch (err) {
      console.error('verifyAndUpdateEmail Error:', err);
      this.setState({
        loading: false,
        errorOtp: true,
        errorMessage: err.message || 'Error verifying OTP code. Please check and try again.',
      });
    }
  };

  renderStep1() {
    return (
      <div>
        <p className="clear mb-20">
          Enter your new email address below. We will send a 6-digit verification code to confirm.
        </p>
        <div className="form-item">
          <label>New Email Address*</label>
          <input
            type="email"
            placeholder="e.g. example@yopmail.com"
            value={this.state.newEmail}
            className={this.state.errorEmail ? 'error' : ''}
            onChange={(e) => this.setState({ newEmail: e.target.value, errorEmail: false, errorMessage: '' })}
            disabled={this.state.loading}
          />
          {this.state.errorMessage && <p className="error">{this.state.errorMessage}</p>}
        </div>
        <div className="sv-10"></div>
        <button className="btn primary" onClick={this.handleSendOTP} disabled={this.state.loading}>
          {this.state.loading ? 'Sending Code...' : 'Send Verification Code'}
        </button>
      </div>
    );
  }

  renderStep2() {
    return (
      <div>
        <p className="clear mb-10">
          Enter the 6-digit code sent to:
        </p>
        <p className="mb-20" style={{ fontWeight: 'bold', color: '#4A90E2' }}>{this.state.newEmail}</p>
        <div className="form-item">
          <label>Verification Code (6-digits)*</label>
          <input
            type="text"
            placeholder="123456"
            maxLength={6}
            value={this.state.otp}
            className={this.state.errorOtp ? 'error' : ''}
            onChange={(e) => this.setState({ otp: e.target.value, errorOtp: false, errorMessage: '' })}
            disabled={this.state.loading}
            style={{ fontSize: '18px', letterSpacing: '4px', textAlign: 'center' }}
          />
          {this.state.errorMessage && <p className="error">{this.state.errorMessage}</p>}
        </div>
        <div className="sv-10"></div>
        <button className="btn primary" onClick={this.handleVerifyOTP} disabled={this.state.loading}>
          {this.state.loading ? 'Verifying...' : 'Verify & Update Email'}
        </button>
        <div className="sv-10"></div>
        <button
          className="btn tertiary small"
          onClick={() => this.setState({ step: 1, otp: '', errorMessage: '', errorOtp: false })}
          disabled={this.state.loading}
          style={{ width: 'auto' }}
        >
          Change Email / Resend Code
        </button>
      </div>
    );
  }

  render() {
    if (this.state.show) {
      return (
        <div className={'overlay ' + this.state.hidden}>
          <div
            className="box auto"
            ref={(divElement) => {
              this.divElement = divElement;
            }}
            style={{ marginTop: this.state.margin }}
          >
            <h2 className="mb-20 lft">Change Email Address</h2>
            <button className="btn tertiary small close rgt" onClick={() => this.hide()}>
              CLOSE
            </button>
            {this.state.step === 1 ? this.renderStep1() : this.renderStep2()}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default ModalEmailOTP;
